import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';
import buildCriteriaQuery from '@/shared/criteria/criterias';

import { ISubmissionHeader } from '@/shared/model/submission-header.model';

const baseApiUrl = 'api/submission-headers';

export default class SubmissionHeaderService {
  public find(id: number): Promise<ISubmissionHeader> {
    return new Promise<ISubmissionHeader>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveByCriteria(paginationQuery?: any, criteriaQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}${buildCriteriaQuery(criteriaQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ISubmissionHeader): Promise<ISubmissionHeader> {
    return new Promise<ISubmissionHeader>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ISubmissionHeader): Promise<ISubmissionHeader> {
    return new Promise<ISubmissionHeader>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateStatus(entity: ISubmissionHeader, newStatus: number): Promise<ISubmissionHeader> {
    return new Promise<ISubmissionHeader>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/status-change/${entity.id}?newStatus=${newStatus}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public reset(entity: ISubmissionHeader): Promise<ISubmissionHeader> {
    return new Promise<ISubmissionHeader>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/reset-maintenance`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateJudgement(entity: ISubmissionHeader): Promise<ISubmissionHeader> {
    return new Promise<ISubmissionHeader>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/updateJudgement-maintenance`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getSubmissionHeaderListExport(criteriaQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/export? ${buildCriteriaQuery(criteriaQuery)}`, {
          responseType: 'arraybuffer'
        })

        .then(function(response) {
          if (!window.navigator.msSaveOrOpenBlob) {
            let filename = response.headers.filename;

            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
          } else {
            let filename = response.headers.filename;
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename);
          }
          resolve('success');
        })
        .catch(err => {
          resolve('err: ' + err);
        });
    });
  }
}
